import React, {useEffect, useRef, useState} from "react";

const GRID_SIZE = 20;
const CELL_SIZE = 20;
const INITIAL_SNAKE = [{x: 8, y: 8}];
const INITIAL_DIRECTION = {x: 1, y: 0};

const SnakeGame = () => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const [snake, setSnake] = useState(INITIAL_SNAKE);
    const [food, setFood] = useState({x: 5, y: 5});
    const [direction, setDirection] = useState(INITIAL_DIRECTION);
    const [gameOver, setGameOver] = useState(false);

    useEffect(() => {
        const handleKey = (e:any) => {
            switch (e.key) {
                case "ArrowUp":
                    setDirection({x: 0, y: -1});
                    break;
                case "ArrowDown":
                    setDirection({x: 0, y: 1});
                    break;
                case "ArrowLeft":
                    setDirection({x: -1, y: 0});
                    break;
                case "ArrowRight":
                    setDirection({x: 1, y: 0});
                    break;
                default:
                    break;
            }
        };

        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, []);

    useEffect(() => {
        if (gameOver) return;

        const interval = setInterval(() => {
            moveSnake();
        }, 150);

        return () => clearInterval(interval);
    });

    const moveSnake = () => {
        setSnake((prevSnake) => {
            const head = {...prevSnake[0]};
            head.x += direction.x;
            head.y += direction.y;

            if (
                head.x < 0 ||
                head.y < 0 ||
                head.x >= GRID_SIZE ||
                head.y >= GRID_SIZE
            ) {
                setGameOver(true);
                return prevSnake;
            }

            for (let segment of prevSnake) {
                if (segment.x === head.x && segment.y === head.y) {
                    setGameOver(true);
                    return prevSnake;
                }
            }

            const newSnake = [head, ...prevSnake];

            if (head.x === food.x && head.y === food.y) {
                setFood({
                    x: Math.floor(Math.random() * GRID_SIZE),
                    y: Math.floor(Math.random() * GRID_SIZE),
                });
            } else {
                newSnake.pop();
            }

            return newSnake;
        });
    };

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = "green";
        snake.forEach((segment) => {
            ctx.fillRect(
                segment.x * CELL_SIZE,
                segment.y * CELL_SIZE,
                CELL_SIZE,
                CELL_SIZE
            );
        });

        ctx.fillStyle = "red";
        ctx.fillRect(
            food.x * CELL_SIZE,
            food.y * CELL_SIZE,
            CELL_SIZE,
            CELL_SIZE
        );
    }, [snake, food]);

    const resetGame = () => {
        setSnake(INITIAL_SNAKE);
        setDirection(INITIAL_DIRECTION);
        setFood({x: 5, y: 5});
        setGameOver(false);
    };

    return (
        <div className={'snake-game-container'}>
            <h3 className={'snake-game-heading'}>🐍 Snake Game</h3>
            <canvas
                ref={canvasRef}
                width={GRID_SIZE * CELL_SIZE}
                height={GRID_SIZE * CELL_SIZE}
                style={{border: "2px solid #333"}}
            />

            {gameOver && (
                <div>
                    <p className={'game-over'}>Game Over</p>
                    <button onClick={resetGame} className={'snake-game-restart'}>Restart</button>
                </div>
            )}
        </div>
    );
};

export default SnakeGame;